import { styled } from '@mui/material/styles';

const HOLE_RADIUS = 8;

/**
 * Default notch colors match the DTicketStyledOverview surface
 * (top → bottom gradient), so existing DTicket usages render unchanged.
 *
 * TODO: default colors can be reused in Activities tab
 */
export const DEFAULT_TOP_NOTCH_COLOR = '#f7f7f7';
export const DEFAULT_BOTTOM_NOTCH_COLOR = '#E2E2E2';

const excludedProps = ['topNotchColor', 'bottomNotchColor'];

export const LogoWrapper = styled('div')(() => ({
	paddingBlock: 10,

	'& svg': {
		width: 60,
		height: 60,
		display: 'block',
	},
}));

export const Root = styled('div')({
	boxShadow:
		'-1px 13px 6px -4px rgba(24, 39, 75, 0.08),0 3px 16px 4px rgba(24, 39, 75, 0.08)',
	overflow: 'hidden',
	borderRadius: 16,
});

export const InnerBox = styled('div', {
	shouldForwardProp: (prop) => !excludedProps.includes(prop as string),
})<{ topNotchColor?: string; bottomNotchColor?: string }>(
	({
		theme,
		topNotchColor = DEFAULT_TOP_NOTCH_COLOR,
		bottomNotchColor = DEFAULT_BOTTOM_NOTCH_COLOR,
	}) => ({
		position: 'relative',
		height: '100%',
		background: 'white',
		borderRadius: 16,
		border: `0.25px solid ${theme.palette.primary[200]}`,
		boxSizing: 'border-box',
		padding: `${HOLE_RADIUS}px 0`,
		display: 'grid',
		gridTemplateColumns: `92px 1px 1fr`,

		'& .dashes': {
			borderRight: `1px dashed ${theme.palette.solutions?.[100]}`,
		},

		'& .slot': {
			paddingInline: '16px',
		},

		'&:hover': {
			cursor: 'pointer',
		},

		'&::before, &::after': {
			content: '""',
			position: 'absolute',
			width: HOLE_RADIUS * 2,
			height: HOLE_RADIUS * 2,
			border: `0.25px solid ${theme.palette.primary[200]}`,
			borderRadius: 100,
			boxSizing: 'border-box',
			left: 85,
		},

		'&::before': {
			backgroundColor: topNotchColor,
			top: HOLE_RADIUS * -1,
		},

		'&::after': {
			backgroundColor: bottomNotchColor,
			bottom: HOLE_RADIUS * -1,
		},
	})
);
